/**
 * SingleEventItem - Proxies to the event registry for single events.
 *
 * Unwraps the TimelineItem and delegates rendering to the appropriate
 * event component based on event_type_name.
 */

import { getEventComponent } from '../events/eventRegistry';
import type { ItemComponentProps } from './types';

export function SingleEventItem({
  item,
  entityType,
  isContext,
}: ItemComponentProps) {
  const event = item.events[0];
  const EventComponent = getEventComponent(event.event_type_name);
  return (
    <EventComponent
      event={event}
      entityType={entityType}
      isContext={isContext}
    />
  );
}
